import React from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputField from "../../form/InputField";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import LoadingButton from "../../form/LoadingButton";
import SubmitButton from "../../form/SubmitButton";

export interface StoreSubTypeFormData {
  languages: {
    languageCode: string;
    title: string;
  }[];
}

interface Props {
  defaultValues: StoreSubTypeFormData;
  id:number;
  onSubmitSuccess?: () => void;
}

const UpdateStoreSubTypeForm: React.FC<Props> = ({ defaultValues, id,onSubmitSuccess }) => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<StoreSubTypeFormData>({
    defaultValues, // prefill the form with provided values
  });

  
      const {loading,updateResource} = useUpdateResource();
  
    const onSubmit: SubmitHandler<StoreSubTypeFormData> = async (data) => {
          const languages = data.languages.map((da)=>({name:da.title,languageCode:da.languageCode}));
          await  updateResource(`subtype/update/${id}`, {languages}, "admin",{
              method: "PUT",
              successMessage: t("update_success"),
              invalidateQueries:["store-sub-types-by-admin"],
            });
          if (onSubmitSuccess) onSubmitSuccess();
    };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="grid sm:grid-cols-2 gap-4"
    >
      {/* English Brand Name */}
      <InputField
        placeholder=""
        label={t("title_en")}
        register={register("languages.0.title", {
          required: t("required_field"),
        })}
        error={errors.languages?.[0]?.title}
      />

      {/* Arabic Brand Name */}
      <InputField
        placeholder=""
        label={t("title_ar")}
        register={register("languages.1.title", {
          required: t("required_field"),
        })}
        error={errors.languages?.[1]?.title}
      />

       {
              loading
              ?
              <LoadingButton/>
              :
              <SubmitButton label={t("update")} />
      }
    </form>
  );
};

export default UpdateStoreSubTypeForm;
